import React from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { uid } from '@/lib/officialsApi';
import { TimeRange } from './TimeRange';

const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export const WeeklyAvailability = ({ entries, update }) => (
  <div className="divide-y" data-testid="weekly-availability">
    {DAYS.map((name, wd) => {
      const rows = entries.filter(e => e.type === 'weekly' && Number(e.weekday) === wd);
      return (
        <div key={wd} className="py-3 flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-3" data-testid={`weekly-day-${wd}`}>
          <div className="sm:w-24 shrink-0 font-semibold text-slate-800 text-sm sm:pt-2">{name}</div>
          <div className="flex-1 space-y-2">
            {rows.length === 0 && <div className="text-sm text-slate-400 sm:pt-2">Not set</div>}
            {rows.map((e, i) => (
              <TimeRange key={e.id} e={e} testId={`weekly-range-${wd}-${i}`}
                onChange={patch => update(p => p.map(x => (x.id === e.id ? { ...x, ...patch } : x)))}
                onRemove={() => update(p => p.filter(x => x.id !== e.id))} />
            ))}
          </div>
          <Button variant="ghost" size="sm" className="self-start text-[#00247D]" data-testid={`weekly-add-${wd}`}
            onClick={() => update(p => [...p, { id: uid(), type: 'weekly', weekday: wd, start: '18:00', end: '22:00' }])}>
            <Plus className="w-4 h-4 mr-1" />Add hours
          </Button>
        </div>
      );
    })}
  </div>
);
